import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import { SelectValue } from 'types/Select';
import Select from '../Select';

type SelectProps = {
  field?: string;
  value?: SelectValue;
  validate?: any;
  label?: string | ReactNode;
  translateLabel?: boolean;
  idKey?: string,
  labelKey?: string,
  placeholder?: string;
  options: any[];
  translateOptions?: boolean;
  validateTranslateValues?: any;
  classNames?: {
    input?: string;
    formGroup?: string;
    label?: string;
  };
  onChange?: ( value: SelectValue ) => void
  showErrors?: boolean;
  isMulti?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
};

function FormSelect( {
  field,
  value,
  validate,
  label,
  translateLabel = true,
  placeholder,
  options,
  translateOptions,
  validateTranslateValues,
  classNames = {},
  onChange,
  showErrors = true,
  isMulti,
  idKey,
  labelKey,
  isLoading,
  isDisabled,
  isClearable,
}: SelectProps ) {
  if ( field ) {
    return (
      <Field name={field} validate={validate}>
        {( { meta, input } ) => {
          const isInvalid = ( meta.touched && !!meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && !!meta.submitError );

          return (
            <Select
              value={input.value}
              onChange={onChange}
              inputOnChange={input.onChange}
              label={label}
              translateLabel={translateLabel}
              placeholder={placeholder}
              options={options}
              translateOptions={translateOptions}
              classNames={classNames}
              showErrors={showErrors}
              validateTranslateValues={validateTranslateValues}
              isInvalid={isInvalid}
              meta={meta}
              isMulti={isMulti}
              isLoading={isLoading}
              isDisabled={isDisabled}
              isClearable={isClearable}
              idKey={idKey}
              labelKey={labelKey}
            />
          );
        }}
      </Field>
    );
  }

  return (
    <Select
      value={value}
      onChange={onChange}
      label={label}
      translateLabel={translateLabel}
      placeholder={placeholder}
      options={options}
      translateOptions={translateOptions}
      validateTranslateValues={validateTranslateValues}
      classNames={classNames}
      showErrors={showErrors}
      isMulti={isMulti}
      isLoading={isLoading}
      isDisabled={isDisabled}
      isClearable={isClearable}
      idKey={idKey}
      labelKey={labelKey}
    />
  );
}

export default FormSelect;
